//Images
import loaderGIF from '@/media/home/loader2.gif';

// Navigation & Menu Icons
import menuIcon from '@/media/icons/menu_icon2.png';
import homeIcon from '@/media/icons/home_icon.png';
import dragDropIcon from '@/media/icons/draganddrop_icon.png';
import sequenceIcon from '@/media/icons/sequence_icon.png';
import loopIcon from '@/media/icons/loop_icon.png';
import loopIcon1 from '@/media/icons/loop_icon1.png';
import eventsIcon from '@/media/icons/events_icon.png';
import conditionalIcon from '@/media/icons/condi_icon.png';
import nestedIcon from '@/media/icons/nested_icon.png';
import functionsIcon from '@/media/icons/functions_icon.png';
import variablesIcon from '@/media/icons/variables_icon.png';
import iconSmall from '@/media/icons/icon-22.png';
import iconMedium from '@/media/icons/icon-24.png';
import icon18 from '@/media/icons/icon18.png';
import icon19 from '@/media/icons/icon19.png';
import icon20 from '@/media/icons/icon20.png';
import icon21 from '@/media/icons/icon21.png';
import icon22 from '@/media/icons/icon22.png';
import icon23 from '@/media/icons/icon23.png';
import p5jsMenuIcon from '@/media/icons/p5jsmenu.png';
import uploadIcon from '@/media/icons/icon-25.png';
import learnImg from '@/media/icons/learn_img.png';
import visitImg from '@/media/icons/visit_img.png';
import exploreImg from '@/media/icons/explore_img.png';
import practiceImg from '@/media/icons/build_practice.png';
import speedIcon1 from '@/media/icons/speed1.png';
import speedIcon2 from '@/media/icons/speed2.png';
import speedIcon3 from '@/media/icons/speed3.png';
import speedIcon4 from '@/media/icons/speed4.png';

// Home Page Images
import activityImg from '@/media/home/codely_activity2.png';
import supraImg from '@/media/home/bot-new.png';
import portalLogo from '@/media/home/portal logo.png';
import backImg from '@/media/home/backImg.png';
import profileImgBoy from '@/media/home/boy_icon.jpg';
import profileImgGirl from '@/media/home/girl_icon.jpg';
import menuIconHome from '@/media/home/menu_icon.png';
import modalCloseButton from '@/media/home/ModalcloseButton.png';
import lxpButtonIcon from '@/media/home/lxpbutton.png';
import bg_home3 from '@/media/home/bg_home3.jpg';

// Block Icons
import dropHereImg from '@/media/blocks/drop_here.png';
import dog1Img from '@/media/blocks/dog1.png';
import dog2Img from '@/media/blocks/dog2.png';
import dog3Img from '@/media/blocks/dog3.png';
import level1Img from '@/media/blocks/image1.png';
import num1Img from '@/media/blocks/num1.png';
import num2Img from '@/media/blocks/num2.png';
import num3Img from '@/media/blocks/num3.png';
import num4Img from '@/media/blocks/num4.png';
import elephant1Img from '@/media/blocks/elephant1.png';
import elephant2Img from '@/media/blocks/elephant2.png';
import elephant3Img from '@/media/blocks/elephant3.png';
import previewImg from '@/media/blocks/preview white.png';

// Game Map Images
import pickupBlockImg from '@/media/Map/fuel.png';
import pickup2BlockImg from '@/media/Map/repair.png';
import treesImg from '@/media/Map/trees.png';
import trees2Img from '@/media/Map/trees2.png';
import foodBoyImg from '@/media/Map/food_boy.png';
import foodBoy2Img from '@/media/Map/food_boy2.png';
import foodBoy3Img from '@/media/Map/food_boy3.png';
import boneImg from '@/media/Map/bone.png';
import bone2Img from '@/media/Map/bone2.png';
import bone3Img from '@/media/Map/bone3.png';

// Audio Files
import dragndropWinAudio from '@/media/dragndrop_win.mp3';

//Blocks and images
import move_east_block from '@/media/blocks/move_east.png';
import move_west_block from '@/media/blocks/move_west.png';
import move_north_block from '@/media/blocks/move_north.png';
import move_south_block from '@/media/blocks/move_south.png';
import repeat_block_img from '@/media/blocks/repeat.png';
import sound_block_img from '@/media/blocks/sound_icon.png';
import music_block_img from '@/media/blocks/music_icon.png';
import click_block_img from '@/media/blocks/click_icon.png';
import collision_block_img from '@/media/blocks/collision_icon.png';
import pickup_block_img from '@/media/Map/fuel.png';
import pickup2_block_img from '@/media/Map/repair.png';
import name_block_img from '@/media/icons/name_block.png';
import count_block_img from '@/media/icons/count_block.png';
import trees_img from '@/media/Map/trees.png';
import trees2_img from '@/media/Map/trees2.png';
import food_boy from '@/media/Map/food_boy.png';
import food_boy2 from '@/media/Map/food_boy2.png';
import food_boy3 from '@/media/Map/food_boy3.png';
import bone from '@/media/Map/bone.png';
import bone2 from '@/media/Map/bone2.png';
import bone3 from '@/media/Map/bone3.png';
import A_key from '@/media/icons/A_Key.png';
import S_key from '@/media/icons/S_Key.png';
import D_key from '@/media/icons/D_Key.png';
import W_key from '@/media/icons/W_Key.png';
import space_key from '@/media/icons/space_bar.png';
//Activity Images
import imgactivity1 from '@/media/activities/activity_1.jpg';
import imgactivity2 from '@/media/activities/activity_2.jpg';
import imgactivity3 from '@/media/activities/activity_3.jpg';
import imgactivity4 from '@/media/activities/activity_4.jpg';
import imgactivity5 from '@/media/activities/activity_5.jpg';
import imgactivity6 from '@/media/activities/activity_6.jpg';
import imgactivity7 from '@/media/activities/activity_7.jpg';
import imgactivity8 from '@/media/activities/activity_8.jpg';
import imgactivity9 from '@/media/activities/activity_9.jpg';
import imgactivity10 from '@/media/activities/activity_10.jpg';
import imgactivity11 from '@/media/activities/activity_11.jpg';
import imgactivity12 from '@/media/activities/activity_12.jpg';
import imgactivity13 from '@/media/activities/activity_13.jpg';
import imgactivity14 from '@/media/activities/activity_14.jpg';
import imgactivity15 from '@/media/activities/activity_15.jpg';
import imgactivity16 from '@/media/activities/activity_16.jpg';
import imgactivity17 from '@/media/activities/activity_17.jpg';
import imgactivity18 from '@/media/activities/activity_18.jpg';
import imgactivity19 from '@/media/activities/activity_19.jpg';
import imgactivity20 from '@/media/activities/activity_20.jpg';
import imgactivity21 from '@/media/activities/activity_21.jpg';
import imgactivity22 from '@/media/activities/activity_22.jpg';
import imgactivity23 from '@/media/activities/activity_23.jpg';
import imgactivity24 from '@/media/activities/activity_24.jpg';
import imgactivity25 from '@/media/activities/activity_25.jpg';
import imgactivity26 from '@/media/activities/activity_26.jpg';
import imgactivity27 from '@/media/activities/activity_27.jpg';
import imgactivity28 from '@/media/activities/activity_28.jpg';
import imgactivity1NoBg from '@/media/activities/activity_1_nobg.png';
import imgactivity2NoBg from '@/media/activities/activity_2_nobg.png';
import imgactivity3NoBg from '@/media/activities/activity_3_nobg.png';
import imgactivity4NoBg from '@/media/activities/activity_4_nobg.png';
import imgactivity5NoBg from '@/media/activities/activity_5_nobg.png';
import imgactivity6NoBg from '@/media/activities/activity_6_nobg.png';
import imgactivity7NoBg from '@/media/activities/activity_7_nobg.png';
import imgactivity8NoBg from '@/media/activities/activity_8_nobg.png';
import imgactivity9NoBg from '@/media/activities/activity_9_nobg.png';
import imgactivity10NoBg from '@/media/activities/activity_10_nobg.png';
import imgactivity11NoBg from '@/media/activities/activity_11_nobg.png';
import imgactivity12NoBg from '@/media/activities/activity_12_nobg.png';
import imgactivity13NoBg from '@/media/activities/activity_13_nobg.png';
import imgactivity14NoBg from '@/media/activities/activity_14_nobg.png';
import imgactivity15NoBg from '@/media/activities/activity_15_nobg.png';
import imgactivity16NoBg from '@/media/activities/activity_16_nobg.png';
import imgactivity17NoBg from '@/media/activities/activity_17_nobg.png';
import imgactivity18NoBg from '@/media/activities/activity_18_nobg.png';
import imgactivity19NoBg from '@/media/activities/activity_19_nobg.png';
import imgactivity20NoBg from '@/media/activities/activity_20_nobg.png';
import imgactivity21NoBg from '@/media/activities/activity_21_nobg.png';
import imgactivity22NoBg from '@/media/activities/activity_22_nobg.png';
import imgactivity23NoBg from '@/media/activities/activity_23_nobg.png';
import imgactivity24NoBg from '@/media/activities/activity_24_nobg.png';
import imgactivity25NoBg from '@/media/activities/activity_25_nobg.png';
import imgactivity26NoBg from '@/media/activities/activity_26_nobg.png';
import imgactivity27NoBg from '@/media/activities/activity_27_nobg.png';
import imgactivity28NoBg from '@/media/activities/activity_28_nobg.png';
//Background Images
import img_animated_back1 from '@/media/Map/events/animated_back1.gif';
import img_animated_back2 from '@/media/Map/events/animated_back2.gif';
import img_animated_back3 from '@/media/Map/events/animated_back3.gif';
import img_back1 from '@/media/Map/events/back1.jpg';
import img_back2 from '@/media/Map/events/back2.jpg';
import img_back3 from '@/media/Map/events/back3.jpg';
import img_back4 from '@/media/Map/events/back4.jpg';
import img_back5 from '@/media/Map/events/back5.jpg';
import img_back6 from '@/media/Map/events/back6.jpg';
import img_back7 from '@/media/Map/events/back7.jpg';
import img_back8 from '@/media/Map/events/back8.jpg';
import img_back9 from '@/media/Map/events/back9.jpg';
import img_back10 from '@/media/Map/events/back10.jpg';
import img_back11 from '@/media/Map/events/back11.jpg';
import img_back12 from '@/media/Map/events/back12.jpg';
import img_back13 from '@/media/Map/events/back13.jpg';
import img_back14 from '@/media/Map/events/back14.jpg';
import img_back15 from '@/media/Map/events/back15.jpg';
import img_back16 from '@/media/Map/events/back16.jpg';
import img_back17 from '@/media/Map/events/back17.jpg';
import img_back18 from '@/media/Map/events/back18.jpg';
import img_back19 from '@/media/Map/events/back19.jpg';
import img_back20 from '@/media/Map/events/back20.jpg';
import img_back21 from '@/media/Map/events/back21.jpg';
import img_back22 from '@/media/Map/events/back22.jpg';
import img_back23 from '@/media/Map/events/back23.jpg';
import img_back24 from '@/media/Map/events/back24.jpg';
import img_back25 from '@/media/Map/events/back25.jpg';
import img_back26 from '@/media/Map/events/back26.jpg';
import img_back27 from '@/media/Map/events/back27.jpg';
import img_back28 from '@/media/Map/events/back28.jpg';
import img_back29 from '@/media/Map/events/back29.jpg';
import img_back30 from '@/media/Map/events/back30.jpg';
import img_back31 from '@/media/Map/events/back31.png';
//Event Characters
import img_char1 from '@/media/Map/events/char1.png';
import img_char2 from '@/media/Map/events/char2.png';
import img_char3 from '@/media/Map/events/char3.png';
import img_char4 from '@/media/Map/events/char4.png';
import img_char5 from '@/media/Map/events/char5.png';
import img_char6 from '@/media/Map/events/char6.png';
import img_monkey_variable from '@/media/Map/events/monkey_variable.png';
import img_food_variable from '@/media/Map/events/food_variable.png';
//Characters
import astro_hit_left from '@/media/Map/char/astro_hit_left.gif';
import astro_hit_right from '@/media/Map/char/astro_hit_right.gif';
import astro_idle_left from '@/media/Map/char/astro_idle_left.gif';
import astro_idle_right from '@/media/Map/char/astro_idle_right.gif';
import astro_moving_left from '@/media/Map/char/astro_moving_left.gif';
import astro_moving_right from '@/media/Map/char/astro_moving_right.gif';
import dog_hit_left from '@/media/Map/char/dog_hit_left.gif';
import dog_hit_right from '@/media/Map/char/dog_hit_right.gif';
import dog_idle_left from '@/media/Map/char/dog_idle_left.gif';
import dog_idle_right from '@/media/Map/char/dog_idle_right.gif';
import dog_moving_left from '@/media/Map/char/dog_moving_left.gif';
import dog_moving_right from '@/media/Map/char/dog_moving_right.gif';
import dog2_hit_left from '@/media/Map/char/dog2_hit_left.gif';
import dog2_hit_right from '@/media/Map/char/dog2_hit_right.gif';
import dog2_idle_left from '@/media/Map/char/dog2_idle_left.gif';
import dog2_idle_right from '@/media/Map/char/dog2_idle_right.gif';
import dog2_moving_left from '@/media/Map/char/dog2_moving_left.gif';
import dog2_moving_right from '@/media/Map/char/dog2_moving_right.gif';
import dog3_hit_left from '@/media/Map/char/dog3_hit_left.gif';
import dog3_hit_right from '@/media/Map/char/dog3_hit_right.gif';
import dog3_idle_left from '@/media/Map/char/dog3_idle_left.gif';
import dog3_idle_right from '@/media/Map/char/dog3_idle_right.gif';
import dog3_moving_left from '@/media/Map/char/dog3_moving_left.gif';
import dog3_moving_right from '@/media/Map/char/dog3_moving_right.gif';
import boy_hit_left from '@/media/Map/char/boy_hit_left.gif';
import boy_hit_right from '@/media/Map/char/boy_hit_right.gif';
import boy_idle_left from '@/media/Map/char/boy_idle_left.gif';
import boy_idle_right from '@/media/Map/char/boy_idle_right.gif';
import boy_moving_left from '@/media/Map/char/boy_moving_left.gif';
import boy_moving_right from '@/media/Map/char/boy_moving_right.gif';
import boy2_hit_left from '@/media/Map/char/boy2_hit_left.gif';
import boy2_hit_right from '@/media/Map/char/boy2_hit_right.gif';
import boy2_idle_left from '@/media/Map/char/boy2_idle_left.gif';
import boy2_idle_right from '@/media/Map/char/boy2_idle_right.gif';
import boy2_moving_left from '@/media/Map/char/boy2_moving_left.gif';
import boy2_moving_right from '@/media/Map/char/boy2_moving_right.gif';
import girl_hit_left from '@/media/Map/char/girl_hit_left.gif';
import girl_hit_right from '@/media/Map/char/girl_hit_right.gif';
import girl_idle_left from '@/media/Map/char/girl_idle_left.gif';
import girl_idle_right from '@/media/Map/char/girl_idle_right.gif';
import girl_moving_left from '@/media/Map/char/girl_moving_left.gif';
import girl_moving_right from '@/media/Map/char/girl_moving_right.gif';
import car_sprite from '@/media/Map/char/car_sprite.png';
import car_hit from '@/media/Map/char/car_hit.gif';
import car_turn_left from '@/media/Map/char/car_turn_left.gif';
import car_turn_right from '@/media/Map/char/car_turn_right.gif';
import bot_img from '@/media/home/bot.png';
//Sounds
import sequence_win_sound from '@/media/sequence_win.mp3';
import sequence_loss_sound from '@/media/sequence_loss.wav';
import nested_loops_win_sound from '@/media/nested_loops_win.mp3';
import nested_loops_loss_sound from '@/media/nested_loops_loss.mp3';
import functions_win_sound from '@/media/functions_win.mp3';
import functions_loss_sound from '@/media/functions_loss.mp3';
import draw_sound1 from '@/media/draw.mp3';
import draw_sound2 from '@/media/draw2.mp3';
import loops1_win_sound from '@/media/loops1_win.mp3';
import loops1_loss_sound from '@/media/loops1_loss.mp3';
import loops2_win_sound from '@/media/loops2_win.mp3';
import loops2_loss_sound from '@/media/loops2_loss.mp3';
import conditionals_win_sound from '@/media/conditionals_win.mp3';
import conditionals_loss_sound from '@/media/conditionals_loss.wav';
import events_win_sound from '@/media/events_win.mp3';
import variables_win_sound from '@/media/variables_win.mp3';
import error_sound_loc from '@/media/error_sound.mp3';
import play_sound_1 from '@/media/Map/events/sounds/1.mp3';
import play_sound_2 from '@/media/Map/events/sounds/2.mp3';
import play_sound_3 from '@/media/Map/events/sounds/3.mp3';
import play_sound_4 from '@/media/Map/events/sounds/4.mp3';
import play_sound_5 from '@/media/Map/events/sounds/5.mp3';
import play_sound_6 from '@/media/Map/events/sounds/6.mp3';
import play_music_1 from '@/media/Map/events/sounds/music1.mp3';
import play_music_2 from '@/media/Map/events/sounds/music2.mp3';
//music notes
import music_note_1 from '@/media/Map/music_notes/note1.mp3';
import music_note_2 from '@/media/Map/music_notes/note2.mp3';
import music_note_3 from '@/media/Map/music_notes/note3.mp3';
import music_note_4 from '@/media/Map/music_notes/note4.mp3';
import music_note_5 from '@/media/Map/music_notes/note5.mp3';
import music_note_6 from '@/media/Map/music_notes/note6.mp3';
import music_note_7 from '@/media/Map/music_notes/note7.mp3';
//instrument 2
import instrument2_note_1 from '@/media/Map/music_notes/instrument2_note1.mp3';
import instrument2_note_2 from '@/media/Map/music_notes/instrument2_note2.mp3';
import instrument2_note_3 from '@/media/Map/music_notes/instrument2_note3.mp3';
import instrument2_note_4 from '@/media/Map/music_notes/instrument2_note4.mp3';
import instrument2_note_5 from '@/media/Map/music_notes/instrument2_note5.mp3';
import instrument2_note_6 from '@/media/Map/music_notes/instrument2_note6.mp3';
import instrument2_note_7 from '@/media/Map/music_notes/instrument2_note7.mp3';
//instrument 4
import instrument4_note_1 from '@/media/Map/music_notes/instrument4_note1.mp3';
import instrument4_note_2 from '@/media/Map/music_notes/instrument4_note2.mp3';
import instrument4_note_3 from '@/media/Map/music_notes/instrument4_note3.mp3';
import instrument4_note_4 from '@/media/Map/music_notes/instrument4_note4.mp3';
import instrument4_note_5 from '@/media/Map/music_notes/instrument4_note5.mp3';
import instrument4_note_6 from '@/media/Map/music_notes/instrument4_note6.mp3';
import instrument4_note_7 from '@/media/Map/music_notes/instrument4_note7.mp3';
//instrument 5
import instrument5_note_1 from '@/media/Map/music_notes/instrument5_note1.mp3';
import instrument5_note_2 from '@/media/Map/music_notes/instrument5_note2.mp3';
import instrument5_note_3 from '@/media/Map/music_notes/instrument5_note3.mp3';
import instrument5_note_4 from '@/media/Map/music_notes/instrument5_note4.mp3';
import instrument5_note_5 from '@/media/Map/music_notes/instrument5_note5.mp3';
import instrument5_note_6 from '@/media/Map/music_notes/instrument5_note6.mp3';
import instrument5_note_7 from '@/media/Map/music_notes/instrument5_note7.mp3';
//instrument 6
import instrument6_note_1 from '@/media/Map/music_notes/instrument6_note1.mp3';
import instrument6_note_2 from '@/media/Map/music_notes/instrument6_note2.mp3';
import instrument6_note_3 from '@/media/Map/music_notes/instrument6_note3.mp3';
import instrument6_note_4 from '@/media/Map/music_notes/instrument6_note4.mp3';
import instrument6_note_5 from '@/media/Map/music_notes/instrument6_note5.mp3';
import instrument6_note_6 from '@/media/Map/music_notes/instrument6_note6.mp3';
import instrument6_note_7 from '@/media/Map/music_notes/instrument6_note7.mp3';

// project pics
import img_project1 from '@/media/Map/events/project1.png';
import img_project2 from '@/media/Map/events/project2.png';
import img_project3 from '@/media/Map/events/project3.png';
import img_project4 from '@/media/Map/events/project4.png';
import img_project5 from '@/media/Map/events/project5.png';
import img_project6 from '@/media/Map/events/project6.png';
import img_project7 from '@/media/Map/events/project7.png';
import img_project8 from '@/media/Map/events/project8.png';
import img_project9 from '@/media/Map/events/project9.png';
import img_project10 from '@/media/Map/events/project10.png';
import img_project11 from '@/media/Map/events/project11.png';
import img_project12 from '@/media/Map/events/project12.png';
import img_project13 from '@/media/Map/events/project13.png';
import img_project14 from '@/media/Map/events/project14.png';
import img_project15 from '@/media/Map/events/project15.png';
import img_project16 from '@/media/Map/events/project16.png';
import img_project17 from '@/media/Map/events/project17.png';
import img_project18 from '@/media/Map/events/project18.png';
import img_project19 from '@/media/Map/events/project19.png';
import img_project20 from '@/media/Map/events/project20.png';
import img_project21 from '@/media/Map/events/project21.png';
import img_project22 from '@/media/Map/events/project22.png';
import img_project23 from '@/media/Map/events/project23.png';
// Sprite 1-12
import img_sprites01 from '@/media/Map/events/sprites-01.png';
import img_sprites02 from '@/media/Map/events/sprites-02.png';
import img_sprites03 from '@/media/Map/events/sprites-03.png';
import img_sprites04 from '@/media/Map/events/sprites-04.png';
import img_sprites05 from '@/media/Map/events/sprites-05.png';
import img_sprites06 from '@/media/Map/events/sprites-06.png';
import img_sprites07 from '@/media/Map/events/sprites-07.png';
import img_sprites08 from '@/media/Map/events/sprites-08.png';
import img_sprites09 from '@/media/Map/events/sprites-09.png';
import img_sprites010 from '@/media/Map/events/sprites-010.png';
import img_sprites011 from '@/media/Map/events/sprites-011.png';
import img_sprites012 from '@/media/Map/events/sprites-012.png';
import img_sprites013 from '@/media/Map/events/sprites-013.png';
import img_sprites014 from '@/media/Map/events/sprites-014.png';
import img_sprites015 from '@/media/Map/events/sprites-015.png';
import img_sprites016 from '@/media/Map/events/sprites-016.png';
import img_sprites017 from '@/media/Map/events/sprites-017.png';
import img_sprites018 from '@/media/Map/events/sprites-018.png';
import img_sprites019 from '@/media/Map/events/sprites-019.png';
import img_sprites020 from '@/media/Map/events/sprites-020.png';
import img_sprites021 from '@/media/Map/events/sprites-021.png';
import img_sprites022 from '@/media/Map/events/sprites-022.png';
import img_sprites023 from '@/media/Map/events/sprites-023.png';
import img_sprites024 from '@/media/Map/events/sprites-024.png';
import img_sprites025 from '@/media/Map/events/sprites-025.png';
import img_sprites026 from '@/media/Map/events/sprites-026.png';
import img_sprites027 from '@/media/Map/events/sprites-027.png';
import img_sprites028 from '@/media/Map/events/sprites-028.png';
import img_sprites029 from '@/media/Map/events/sprites-029.png';
import img_sprites030 from '@/media/Map/events/sprites-030.png';
import img_sprites031 from '@/media/Map/events/sprites-031.png';
import img_sprites032 from '@/media/Map/events/sprites-032.png';
import img_sprites033 from '@/media/Map/events/sprites-033.png';
import img_sprites034 from '@/media/Map/events/sprites-034.png';
import img_sprites035 from '@/media/Map/events/sprites-035.png';
import img_sprites036 from '@/media/Map/events/sprites-036.png';
import img_sprites037 from '@/media/Map/events/sprites-037.png';
import img_sprites038 from '@/media/Map/events/sprites-038.png';
import img_sprites039 from '@/media/Map/events/sprites-039.png';
import img_sprites040 from '@/media/Map/events/sprites-040.png';
import img_sprites041 from '@/media/Map/events/sprites-041.png';
import img_sprites042 from '@/media/Map/events/sprites-042.png';
import img_sprites043 from '@/media/Map/events/sprites-043.png';
import img_sprites044 from '@/media/Map/events/sprites-044.png';
import img_sprites045 from '@/media/Map/events/sprites-045.png';
import img_sprites046 from '@/media/Map/events/sprites-046.png';
import img_sprites047 from '@/media/Map/events/sprites-047.png';
import img_sprites048 from '@/media/Map/events/sprites-048.png';
import img_sprites049 from '@/media/Map/events/sprites-049.png';
import img_sprites050 from '@/media/Map/events/sprites-050.png';
import img_sprites051 from '@/media/Map/events/sprites-051.png';
import img_sprites052 from '@/media/Map/events/sprites-052.png';
import img_sprites053 from '@/media/Map/events/sprites-053.png';
import img_sprites054 from '@/media/Map/events/sprites-054.png';
import img_sprites055 from '@/media/Map/events/sprites-055.png';
import img_sprites056 from '@/media/Map/events/sprites-056.png';
import img_sprites057 from '@/media/Map/events/sprites-057.gif';
import img_sprites058 from '@/media/Map/events/sprites-058.gif';
import img_sprites059 from '@/media/Map/events/sprites-059.gif';
import img_sprites060 from '@/media/Map/events/sprites-060.gif';
import img_sprites061 from '@/media/Map/events/sprites-061.png';
import img_all from '@/media/Map/events/all.png';
import img_boundary from '@/media/Map/events/boundary.png';
import img_boundary_x from '@/media/Map/events/boundary-x.png';
import img_boundary_y from '@/media/Map/events/boundary-y.png';
import img_boundary_t from '@/media/Map/events/boundary-t.png';
import img_boundary_b from '@/media/Map/events/boundary-b.png';
import img_boundary_l from '@/media/Map/events/boundary-l.png';
import img_boundary_r from '@/media/Map/events/boundary-r.png';
import img_food_boy from '@/media/Map/events/food_boy.png';
import img_food_boy2 from '@/media/Map/events/food_boy2.png';
//Cursors
import img_char_cursor1 from '@/media/Map/char_cursor1.png';
import img_char_cursor2 from '@/media/Map/char_cursor2.png';
import img_char_cursor3 from '@/media/Map/char_cursor3.png';
import img_char_cursor4 from '@/media/Map/char_cursor4.png';
import img_char_cursor5 from '@/media/Map/char_cursor5.png';
import img_char_cursor6 from '@/media/Map/char_cursor6.png';
import img_function1 from '@/media/Map/functions_1.png';
import img_function2 from '@/media/Map/functions_2.png';
import img_function3 from '@/media/Map/functions_3.png';
import img_function4 from '@/media/Map/functions_4.png';
import img_triangle from '@/media/Map/triangle.png';
import img_squares from '@/media/Map/squares.png';
import img_circle from '@/media/Map/circle.png';
//Piano Sounds
import note_A4 from '@/media/Map/music_notes/Piano/A4.mp3';
import note_A5 from '@/media/Map/music_notes/Piano/A5.mp3';
import note_Ab4 from '@/media/Map/music_notes/Piano/Ab4.mp3';
import note_Ab5 from '@/media/Map/music_notes/Piano/Ab5.mp3';
import note_B4 from '@/media/Map/music_notes/Piano/B4.mp3';
import note_B5 from '@/media/Map/music_notes/Piano/B5.mp3';
import note_Bb4 from '@/media/Map/music_notes/Piano/Bb4.mp3';
import note_Bb5 from '@/media/Map/music_notes/Piano/Bb5.mp3';
import note_C4 from '@/media/Map/music_notes/Piano/C4.mp3';
import note_C5 from '@/media/Map/music_notes/Piano/C5.mp3';
import note_D4 from '@/media/Map/music_notes/Piano/D4.mp3';
import note_D5 from '@/media/Map/music_notes/Piano/D5.mp3';
import note_Db4 from '@/media/Map/music_notes/Piano/Db4.mp3';
import note_Db5 from '@/media/Map/music_notes/Piano/Db5.mp3';
import note_E4 from '@/media/Map/music_notes/Piano/E4.mp3';
import note_E5 from '@/media/Map/music_notes/Piano/E5.mp3';
import note_Eb4 from '@/media/Map/music_notes/Piano/Eb4.mp3';
import note_Eb5 from '@/media/Map/music_notes/Piano/Eb5.mp3';
import note_F4 from '@/media/Map/music_notes/Piano/F4.mp3';
import note_F5 from '@/media/Map/music_notes/Piano/F5.mp3';
import note_G4 from '@/media/Map/music_notes/Piano/G4.mp3';
import note_G5 from '@/media/Map/music_notes/Piano/G5.mp3';
import note_Gb4 from '@/media/Map/music_notes/Piano/Gb4.mp3';
import note_Gb5 from '@/media/Map/music_notes/Piano/Gb5.mp3';
//Guitar Sounds
import guitar_A4 from '@/media/Map/music_notes/Guitar/A4.mp3';
import guitar_A5 from '@/media/Map/music_notes/Guitar/A5.mp3';
import guitar_Ab4 from '@/media/Map/music_notes/Guitar/Ab4.mp3';
import guitar_Ab5 from '@/media/Map/music_notes/Guitar/Ab5.mp3';
import guitar_B4 from '@/media/Map/music_notes/Guitar/B4.mp3';
import guitar_B5 from '@/media/Map/music_notes/Guitar/B5.mp3';
import guitar_Bb4 from '@/media/Map/music_notes/Guitar/Bb4.mp3';
import guitar_Bb5 from '@/media/Map/music_notes/Guitar/Bb5.mp3';
import guitar_C4 from '@/media/Map/music_notes/Guitar/C4.mp3';
import guitar_C5 from '@/media/Map/music_notes/Guitar/C5.mp3';
import guitar_D4 from '@/media/Map/music_notes/Guitar/D4.mp3';
import guitar_D5 from '@/media/Map/music_notes/Guitar/D5.mp3';
import guitar_Db4 from '@/media/Map/music_notes/Guitar/Db4.mp3';
import guitar_Db5 from '@/media/Map/music_notes/Guitar/Db5.mp3';
import guitar_E4 from '@/media/Map/music_notes/Guitar/E4.mp3';
import guitar_E5 from '@/media/Map/music_notes/Guitar/E5.mp3';
import guitar_Eb4 from '@/media/Map/music_notes/Guitar/Eb4.mp3';
import guitar_Eb5 from '@/media/Map/music_notes/Guitar/Eb5.mp3';
import guitar_F4 from '@/media/Map/music_notes/Guitar/F4.mp3';
import guitar_F5 from '@/media/Map/music_notes/Guitar/F5.mp3';
import guitar_G4 from '@/media/Map/music_notes/Guitar/G4.mp3';
import guitar_G5 from '@/media/Map/music_notes/Guitar/G5.mp3';
import guitar_Gb4 from '@/media/Map/music_notes/Guitar/Gb4.mp3';
import guitar_Gb5 from '@/media/Map/music_notes/Guitar/Gb5.mp3';
//Flute Sounds
import flute_A4 from '@/media/Map/music_notes/Flute/flute_A4.mp3';
import flute_A5 from '@/media/Map/music_notes/Flute/flute_A5.mp3';
import flute_Ab4 from '@/media/Map/music_notes/Flute/flute_Ab4.mp3';
import flute_Ab5 from '@/media/Map/music_notes/Flute/flute_Ab5.mp3';
import flute_B4 from '@/media/Map/music_notes/Flute/flute_B4.mp3';
import flute_B5 from '@/media/Map/music_notes/Flute/flute_B5.mp3';
import flute_Bb4 from '@/media/Map/music_notes/Flute/flute_Bb4.mp3';
import flute_Bb5 from '@/media/Map/music_notes/Flute/flute_Bb5.mp3';
import flute_C4 from '@/media/Map/music_notes/Flute/flute_C4.mp3';
import flute_C5 from '@/media/Map/music_notes/Flute/flute_C5.mp3';
import flute_D4 from '@/media/Map/music_notes/Flute/flute_D4.mp3';
import flute_D5 from '@/media/Map/music_notes/Flute/flute_D5.mp3';
import flute_Db4 from '@/media/Map/music_notes/Flute/flute_Db4.mp3';
import flute_Db5 from '@/media/Map/music_notes/Flute/flute_Db5.mp3';
import flute_E4 from '@/media/Map/music_notes/Flute/flute_E4.mp3';
import flute_E5 from '@/media/Map/music_notes/Flute/flute_E5.mp3';
import flute_Eb4 from '@/media/Map/music_notes/Flute/flute_Eb4.mp3';
import flute_Eb5 from '@/media/Map/music_notes/Flute/flute_Eb5.mp3';
import flute_F4 from '@/media/Map/music_notes/Flute/flute_F4.mp3';
import flute_F5 from '@/media/Map/music_notes/Flute/flute_F5.mp3';
import flute_G4 from '@/media/Map/music_notes/Flute/flute_G4.mp3';
import flute_G5 from '@/media/Map/music_notes/Flute/flute_G5.mp3';
import flute_Gb4 from '@/media/Map/music_notes/Flute/flute_Gb4.mp3';
import flute_Gb5 from '@/media/Map/music_notes/Flute/flute_Gb5.mp3';
// Bell Sounds
import bell_A4 from '@/media/Map/music_notes/Bells/A4.mp3';
import bell_A5 from '@/media/Map/music_notes/Bells/A5.mp3';
import bell_Ab4 from '@/media/Map/music_notes/Bells/Ab4.mp3';
import bell_Ab5 from '@/media/Map/music_notes/Bells/Ab5.mp3';
import bell_B4 from '@/media/Map/music_notes/Bells/B4.mp3';
import bell_B5 from '@/media/Map/music_notes/Bells/B5.mp3';
import bell_Bb4 from '@/media/Map/music_notes/Bells/Bb4.mp3';
import bell_Bb5 from '@/media/Map/music_notes/Bells/Bb5.mp3';
import bell_C4 from '@/media/Map/music_notes/Bells/C4.mp3';
import bell_C5 from '@/media/Map/music_notes/Bells/C5.mp3';
import bell_D4 from '@/media/Map/music_notes/Bells/D4.mp3';
import bell_D5 from '@/media/Map/music_notes/Bells/D5.mp3';
import bell_Db4 from '@/media/Map/music_notes/Bells/Db4.mp3';
import bell_Db5 from '@/media/Map/music_notes/Bells/Db5.mp3';
import bell_E4 from '@/media/Map/music_notes/Bells/E4.mp3';
import bell_E5 from '@/media/Map/music_notes/Bells/E5.mp3';
import bell_Eb4 from '@/media/Map/music_notes/Bells/Eb4.mp3';
import bell_Eb5 from '@/media/Map/music_notes/Bells/Eb5.mp3';
import bell_F4 from '@/media/Map/music_notes/Bells/F4.mp3';
import bell_F5 from '@/media/Map/music_notes/Bells/F5.mp3';
import bell_G4 from '@/media/Map/music_notes/Bells/G4.mp3';
import bell_G5 from '@/media/Map/music_notes/Bells/G5.mp3';
import bell_Gb4 from '@/media/Map/music_notes/Bells/Gb4.mp3';
import bell_Gb5 from '@/media/Map/music_notes/Bells/Gb5.mp3';
export {
  note_A4,
  note_A5,
  note_Ab4,
  note_Ab5,
  note_B4,
  note_B5,
  note_Bb4,
  note_Bb5,
  note_C4,
  note_C5,
  note_D4,
  note_D5,
  note_Db4,
  note_Db5,
  note_E4,
  note_E5,
  note_Eb4,
  note_Eb5,
  note_F4,
  note_F5,
  note_G4,
  note_G5,
  note_Gb4,
  note_Gb5,
  flute_A4,
  flute_A5,
  flute_Ab4,
  flute_Ab5,
  flute_B4,
  flute_B5,
  flute_Bb4,
  flute_Bb5,
  flute_C4,
  flute_C5,
  flute_D4,
  flute_D5,
  flute_Db4,
  flute_Db5,
  flute_E4,
  flute_E5,
  flute_Eb4,
  flute_Eb5,
  flute_F4,
  flute_F5,
  flute_G4,
  flute_G5,
  flute_Gb4,
  flute_Gb5,
  guitar_A4,
  guitar_A5,
  guitar_Ab4,
  guitar_Ab5,
  guitar_B4,
  guitar_B5,
  guitar_Bb4,
  guitar_Bb5,
  guitar_C4,
  guitar_C5,
  guitar_D4,
  guitar_D5,
  guitar_Db4,
  guitar_Db5,
  guitar_E4,
  guitar_E5,
  guitar_Eb4,
  guitar_Eb5,
  guitar_F4,
  guitar_F5,
  guitar_G4,
  guitar_G5,
  guitar_Gb4,
  guitar_Gb5,
  bell_A4,
  bell_A5,
  bell_Ab4,
  bell_Ab5,
  bell_B4,
  bell_B5,
  bell_Bb4,
  bell_Bb5,
  bell_C4,
  bell_C5,
  bell_D4,
  bell_D5,
  bell_Db4,
  bell_Db5,
  bell_E4,
  bell_E5,
  bell_Eb4,
  bell_Eb5,
  bell_F4,
  bell_F5,
  bell_G4,
  bell_G5,
  bell_Gb4,
  bell_Gb5,
};
export {
  loaderGIF,
  img_all,
  img_boundary,
  img_boundary_x,
  img_boundary_y,
  img_boundary_t,
  img_boundary_b,
  img_boundary_l,
  img_boundary_r,
  move_east_block,
  move_north_block,
  move_south_block,
  move_west_block,
  A_key,
  S_key,
  D_key,
  W_key,
  space_key,
  pickup2_block_img,
  pickup_block_img,
  repeat_block_img,
  click_block_img,
  collision_block_img,
  name_block_img,
  count_block_img,
  sound_block_img,
  music_block_img,
  trees_img,
  trees2_img,
  food_boy,
  food_boy2,
  food_boy3,
  bone,
  bone2,
  bone3,
};
export {
  img_char1,
  img_char2,
  img_char3,
  img_char4,
  img_char5,
  img_char6,
  img_food_variable,
  img_monkey_variable,
};
export {
  astro_moving_left,
  astro_moving_right,
  astro_hit_left,
  astro_hit_right,
  astro_idle_left,
  astro_idle_right,
  dog_hit_left,
  dog_hit_right,
  dog_idle_left,
  dog_idle_right,
  dog_moving_left,
  dog_moving_right,
  dog2_hit_left,
  dog2_hit_right,
  dog2_idle_left,
  dog2_idle_right,
  dog2_moving_left,
  dog2_moving_right,
  dog3_hit_left,
  dog3_hit_right,
  dog3_idle_left,
  dog3_idle_right,
  dog3_moving_left,
  bot_img,
  dog3_moving_right,
  boy_hit_left,
  boy_hit_right,
  boy_idle_left,
  boy_idle_right,
  boy_moving_left,
  boy_moving_right,
  boy2_hit_left,
  boy2_hit_right,
  boy2_idle_left,
  boy2_idle_right,
  boy2_moving_left,
  boy2_moving_right,
  girl_hit_left,
  girl_hit_right,
  girl_idle_left,
  girl_idle_right,
  girl_moving_left,
  girl_moving_right,
  car_sprite,
  car_hit,
  car_turn_left,
  car_turn_right,
};
export {
  img_animated_back1,
  img_animated_back2,
  img_animated_back3,
  img_back1,
  img_back2,
  img_back3,
  img_back4,
  img_back5,
  img_back6,
  img_back7,
  img_back8,
  img_back9,
  img_back10,
  img_back11,
  img_back12,
  img_back13,
  img_back14,
  img_back15,
  img_back16,
  img_back17,
  img_back18,
  img_back19,
  img_back20,
  img_back21,
  img_back22,
  img_back23,
  img_back24,
  img_back25,
  img_back26,
  img_back27,
  img_back28,
  img_back29,
  img_back30,
  img_back31,
};
export {
  img_project1,
  img_project2,
  img_project3,
  img_project4,
  img_project5,
  img_project6,
  img_project7,
  img_project8,
  img_project9,
  img_project10,
  img_project11,
  img_project12,
  img_project13,
  img_project14,
  img_project15,
  img_project16,
  img_project17,
  img_project18,
  img_project19,
  img_project20,
  img_project21,
  img_project22,
  img_project23,
};
export {
  img_sprites01,
  img_sprites02,
  img_sprites03,
  img_sprites04,
  img_sprites05,
  img_sprites06,
  img_sprites07,
  img_sprites08,
  img_sprites09,
  img_sprites010,
  img_sprites011,
  img_sprites012,
  img_sprites013,
  img_sprites014,
  img_sprites015,
  img_sprites016,
  img_sprites017,
  img_sprites018,
  img_sprites019,
  img_sprites020,
  img_sprites021,
  img_sprites022,
  img_sprites023,
  img_sprites024,
  img_sprites025,
  img_sprites026,
  img_sprites027,
  img_sprites028,
  img_sprites029,
  img_sprites030,
  img_sprites031,
  img_sprites032,
  img_sprites033,
  img_sprites034,
  img_sprites035,
  img_sprites036,
  img_sprites037,
  img_sprites038,
  img_sprites039,
  img_sprites040,
  img_sprites041,
  img_sprites042,
  img_sprites043,
  img_sprites044,
  img_sprites045,
  img_sprites046,
  img_sprites047,
  img_sprites048,
  img_sprites049,
  img_sprites050,
  img_sprites051,
  img_sprites052,
  img_sprites053,
  img_sprites054,
  img_sprites055,
  img_sprites056,
  img_sprites057,
  img_sprites058,
  img_sprites059,
  img_sprites060,
  img_sprites061,
  img_food_boy,
  img_food_boy2,
};
export {
  nested_loops_loss_sound,
  nested_loops_win_sound,
  functions_loss_sound,
  functions_win_sound,
  draw_sound1,
  draw_sound2,
  sequence_loss_sound,
  sequence_win_sound,
  loops1_loss_sound,
  loops1_win_sound,
  loops2_loss_sound,
  loops2_win_sound,
  conditionals_loss_sound,
  conditionals_win_sound,
  events_win_sound,
  variables_win_sound,
  error_sound_loc,
  play_sound_1,
  play_sound_2,
  play_sound_3,
  play_sound_4,
  play_sound_5,
  play_sound_6,
  play_music_1,
  play_music_2,
};
export {
  img_char_cursor1,
  img_char_cursor2,
  img_char_cursor3,
  img_char_cursor4,
  img_char_cursor5,
  img_char_cursor6,
  img_circle,
  img_function1,
  img_function2,
  img_function3,
  img_function4,
  img_squares,
  img_triangle,
};
export {
  imgactivity1,
  imgactivity2,
  imgactivity3,
  imgactivity4,
  imgactivity5,
  imgactivity6,
  imgactivity7,
  imgactivity8,
  imgactivity9,
  imgactivity10,
  imgactivity11,
  imgactivity12,
  imgactivity13,
  imgactivity14,
  imgactivity15,
  imgactivity16,
  imgactivity17,
  imgactivity18,
  imgactivity19,
  imgactivity20,
  imgactivity21,
  imgactivity22,
  imgactivity23,
  imgactivity24,
  imgactivity25,
  imgactivity26,
  imgactivity27,
  imgactivity28,
  imgactivity1NoBg,
  imgactivity2NoBg,
  imgactivity3NoBg,
  imgactivity4NoBg,
  imgactivity5NoBg,
  imgactivity6NoBg,
  imgactivity7NoBg,
  imgactivity8NoBg,
  imgactivity9NoBg,
  imgactivity10NoBg,
  imgactivity11NoBg,
  imgactivity12NoBg,
  imgactivity13NoBg,
  imgactivity14NoBg,
  imgactivity15NoBg,
  imgactivity16NoBg,
  imgactivity17NoBg,
  imgactivity18NoBg,
  imgactivity19NoBg,
  imgactivity20NoBg,
  imgactivity21NoBg,
  imgactivity22NoBg,
  imgactivity23NoBg,
  imgactivity24NoBg,
  imgactivity25NoBg,
  imgactivity26NoBg,
  imgactivity27NoBg,
  imgactivity28NoBg,
};

// ===== IMAGE OBJECT MAPS =====

export const navigationIcons = {
  menu: menuIcon,
  home: homeIcon,
  dragDrop: dragDropIcon,
  sequence: sequenceIcon,
  loop: loopIcon,
  loop1: loopIcon1,
  events: eventsIcon,
  conditional: conditionalIcon,
  nested: nestedIcon,
  functions: functionsIcon,
  variables: variablesIcon,
  icon_small: iconSmall,
  icon_medium: iconMedium,
  icon18: icon18,
  icon19: icon19,
  icon20: icon20,
  icon21: icon21,
  icon22: icon22,
  icon23: icon23,
  p5js: p5jsMenuIcon,
  upload: uploadIcon,
  learn: learnImg,
  visit: visitImg,
  explore: exploreImg,
  practice: practiceImg,
  nameBlock: name_block_img,
  countBlock: count_block_img,
  keyA: A_key,
  keyS: S_key,
  keyD: D_key,
  keyW: W_key,
  keySpace: space_key,
  speed1: speedIcon1,
  speed2: speedIcon2,
  speed3: speedIcon3,
  speed4: speedIcon4,
};

export const homePageImages = {
  activity: activityImg,
  supra: supraImg,
  portalLogo: portalLogo,
  back: backImg,
  profileBoy: profileImgBoy,
  profileGirl: profileImgGirl,
  menuIcon: menuIconHome,
  modalClose: modalCloseButton,
  lxpButton: lxpButtonIcon,
  loader: loaderGIF,
  bg: bg_home3,
};

export const blockIcons = {
  dropHere: dropHereImg,
  dog1: dog1Img,
  dog2: dog2Img,
  dog3: dog3Img,
  level1: level1Img,
  num1: num1Img,
  num2: num2Img,
  num3: num3Img,
  num4: num4Img,
  elephant1: elephant1Img,
  elephant2: elephant2Img,
  elephant3: elephant3Img,
  preview: previewImg,
  moveEast: move_east_block,
  moveWest: move_west_block,
  moveNorth: move_north_block,
  moveSouth: move_south_block,
  repeat: repeat_block_img,
  sound: sound_block_img,
  music: music_block_img,
  click: click_block_img,
  collision: collision_block_img,
};

export const gameMapImages = {
  pickup: pickupBlockImg,
  pickup2: pickup2BlockImg,
  trees: treesImg,
  trees2: trees2Img,
  foodBoy: foodBoyImg,
  foodBoy2: foodBoy2Img,
  foodBoy3: foodBoy3Img,
  bone: boneImg,
  bone2: bone2Img,
  bone3: bone3Img,
};

export const activityImages = {
  activity1: imgactivity1,
  activity2: imgactivity2,
  activity3: imgactivity3,
  activity4: imgactivity4,
  activity5: imgactivity5,
  activity6: imgactivity6,
  activity7: imgactivity7,
  activity8: imgactivity8,
  activity9: imgactivity9,
  activity10: imgactivity10,
  activity11: imgactivity11,
  activity12: imgactivity12,
  activity13: imgactivity13,
  activity14: imgactivity14,
  activity15: imgactivity15,
  activity16: imgactivity16,
  activity17: imgactivity17,
  activity18: imgactivity18,
  activity19: imgactivity19,
  activity20: imgactivity20,
  activity21: imgactivity21,
  activity22: imgactivity22,
  activity23: imgactivity23,
  activity24: imgactivity24,
  activity25: imgactivity25,
  activity26: imgactivity26,
  activity27: imgactivity27,
  activity28: imgactivity28,
  activity1_nobg: imgactivity1NoBg,
  activity2_nobg: imgactivity2NoBg,
  activity3_nobg: imgactivity3NoBg,
  activity4_nobg: imgactivity4NoBg,
  activity5_nobg: imgactivity5NoBg,
  activity6_nobg: imgactivity6NoBg,
  activity7_nobg: imgactivity7NoBg,
  activity8_nobg: imgactivity8NoBg,
  activity9_nobg: imgactivity9NoBg,
  activity10_nobg: imgactivity10NoBg,
  activity11_nobg: imgactivity11NoBg,
  activity12_nobg: imgactivity12NoBg,
  activity13_nobg: imgactivity13NoBg,
  activity14_nobg: imgactivity14NoBg,
  activity15_nobg: imgactivity15NoBg,
  activity16_nobg: imgactivity16NoBg,
  activity17_nobg: imgactivity17NoBg,
  activity18_nobg: imgactivity18NoBg,
  activity19_nobg: imgactivity19NoBg,
  activity20_nobg: imgactivity20NoBg,
  activity21_nobg: imgactivity21NoBg,
  activity22_nobg: imgactivity22NoBg,
  activity23_nobg: imgactivity23NoBg,
  activity24_nobg: imgactivity24NoBg,
  activity25_nobg: imgactivity25NoBg,
  activity26_nobg: imgactivity26NoBg,
  activity27_nobg: imgactivity27NoBg,
  activity28_nobg: imgactivity28NoBg,
};

export const audioFiles = {
  // Game sounds
  dragndropWin: dragndropWinAudio,
  sequence_win_sound: sequence_win_sound,
  sequence_loss_sound: sequence_loss_sound,
  nested_loops_win_sound: nested_loops_win_sound,
  nested_loops_loss_sound: nested_loops_loss_sound,
  functions_win_sound: functions_win_sound,
  functions_loss_sound: functions_loss_sound,
  draw_sound1: draw_sound1,
  draw_sound2: draw_sound2,
  loops1_win_sound: loops1_win_sound,
  loops1_loss_sound: loops1_loss_sound,
  loops2_win_sound: loops2_win_sound,
  loops2_loss_sound: loops2_loss_sound,
  conditionals_win_sound: conditionals_win_sound,
  conditionals_loss_sound: conditionals_loss_sound,
  events_win_sound: events_win_sound,
  variables_win_sound: variables_win_sound,
  error_sound: error_sound_loc,

  // Event sounds
  play_sound_1: play_sound_1,
  play_sound_2: play_sound_2,
  play_sound_3: play_sound_3,
  play_sound_4: play_sound_4,
  play_sound_5: play_sound_5,
  play_sound_6: play_sound_6,
  play_music_1: play_music_1,
  play_music_2: play_music_2,

  // Music notes (basic)
  music_note_1: music_note_1,
  music_note_2: music_note_2,
  music_note_3: music_note_3,
  music_note_4: music_note_4,
  music_note_5: music_note_5,
  music_note_6: music_note_6,
  music_note_7: music_note_7,

  // Instrument 2
  instrument2_note_1: instrument2_note_1,
  instrument2_note_2: instrument2_note_2,
  instrument2_note_3: instrument2_note_3,
  instrument2_note_4: instrument2_note_4,
  instrument2_note_5: instrument2_note_5,
  instrument2_note_6: instrument2_note_6,
  instrument2_note_7: instrument2_note_7,

  // Instrument 4
  instrument4_note_1: instrument4_note_1,
  instrument4_note_2: instrument4_note_2,
  instrument4_note_3: instrument4_note_3,
  instrument4_note_4: instrument4_note_4,
  instrument4_note_5: instrument4_note_5,
  instrument4_note_6: instrument4_note_6,
  instrument4_note_7: instrument4_note_7,

  // Instrument 5
  instrument5_note_1: instrument5_note_1,
  instrument5_note_2: instrument5_note_2,
  instrument5_note_3: instrument5_note_3,
  instrument5_note_4: instrument5_note_4,
  instrument5_note_5: instrument5_note_5,
  instrument5_note_6: instrument5_note_6,
  instrument5_note_7: instrument5_note_7,

  // Instrument 6
  instrument6_note_1: instrument6_note_1,
  instrument6_note_2: instrument6_note_2,
  instrument6_note_3: instrument6_note_3,
  instrument6_note_4: instrument6_note_4,
  instrument6_note_5: instrument6_note_5,
  instrument6_note_6: instrument6_note_6,
  instrument6_note_7: instrument6_note_7,

  // Piano notes
  note_A4: note_A4,
  note_A5: note_A5,
  note_Ab4: note_Ab4,
  note_Ab5: note_Ab5,
  note_B4: note_B4,
  note_B5: note_B5,
  note_Bb4: note_Bb4,
  note_Bb5: note_Bb5,
  note_C4: note_C4,
  note_C5: note_C5,
  note_D4: note_D4,
  note_D5: note_D5,
  note_Db4: note_Db4,
  note_Db5: note_Db5,
  note_E4: note_E4,
  note_E5: note_E5,
  note_Eb4: note_Eb4,
  note_Eb5: note_Eb5,
  note_F4: note_F4,
  note_F5: note_F5,
  note_G4: note_G4,
  note_G5: note_G5,
  note_Gb4: note_Gb4,
  note_Gb5: note_Gb5,

  // Guitar notes
  guitar_A4: guitar_A4,
  guitar_A5: guitar_A5,
  guitar_Ab4: guitar_Ab4,
  guitar_Ab5: guitar_Ab5,
  guitar_B4: guitar_B4,
  guitar_B5: guitar_B5,
  guitar_Bb4: guitar_Bb4,
  guitar_Bb5: guitar_Bb5,
  guitar_C4: guitar_C4,
  guitar_C5: guitar_C5,
  guitar_D4: guitar_D4,
  guitar_D5: guitar_D5,
  guitar_Db4: guitar_Db4,
  guitar_Db5: guitar_Db5,
  guitar_E4: guitar_E4,
  guitar_E5: guitar_E5,
  guitar_Eb4: guitar_Eb4,
  guitar_Eb5: guitar_Eb5,
  guitar_F4: guitar_F4,
  guitar_F5: guitar_F5,
  guitar_G4: guitar_G4,
  guitar_G5: guitar_G5,
  guitar_Gb4: guitar_Gb4,
  guitar_Gb5: guitar_Gb5,

  // Flute notes
  flute_A4: flute_A4,
  flute_A5: flute_A5,
  flute_Ab4: flute_Ab4,
  flute_Ab5: flute_Ab5,
  flute_B4: flute_B4,
  flute_B5: flute_B5,
  flute_Bb4: flute_Bb4,
  flute_Bb5: flute_Bb5,
  flute_C4: flute_C4,
  flute_C5: flute_C5,
  flute_D4: flute_D4,
  flute_D5: flute_D5,
  flute_Db4: flute_Db4,
  flute_Db5: flute_Db5,
  flute_E4: flute_E4,
  flute_E5: flute_E5,
  flute_Eb4: flute_Eb4,
  flute_Eb5: flute_Eb5,
  flute_F4: flute_F4,
  flute_F5: flute_F5,
  flute_G4: flute_G4,
  flute_G5: flute_G5,
  flute_Gb4: flute_Gb4,
  flute_Gb5: flute_Gb5,

  // Bell notes
  bell_A4: bell_A4,
  bell_A5: bell_A5,
  bell_Ab4: bell_Ab4,
  bell_Ab5: bell_Ab5,
  bell_B4: bell_B4,
  bell_B5: bell_B5,
  bell_Bb4: bell_Bb4,
  bell_Bb5: bell_Bb5,
  bell_C4: bell_C4,
  bell_C5: bell_C5,
  bell_D4: bell_D4,
  bell_D5: bell_D5,
  bell_Db4: bell_Db4,
  bell_Db5: bell_Db5,
  bell_E4: bell_E4,
  bell_E5: bell_E5,
  bell_Eb4: bell_Eb4,
  bell_Eb5: bell_Eb5,
  bell_F4: bell_F4,
  bell_F5: bell_F5,
  bell_G4: bell_G4,
  bell_G5: bell_G5,
  bell_Gb4: bell_Gb4,
  bell_Gb5: bell_Gb5,
};

// Mapping for navigation icon indexes (for dynamic access by number)
export const iconIndexMap = {
  1: navigationIcons.menu,
  2: navigationIcons.home,
  3: navigationIcons.dragDrop,
  4: navigationIcons.sequence,
  5: navigationIcons.loop,
  6: navigationIcons.loop1,
  7: navigationIcons.events,
  8: navigationIcons.conditional,
  9: navigationIcons.nested,
  10: navigationIcons.functions,
  11: navigationIcons.variables,
  12: navigationIcons.icon_small,
  13: navigationIcons.icon_medium,
  15: homePageImages.activity,
  16: homePageImages.menuIcon,
  17: navigationIcons.icon_medium,
  18: navigationIcons.icon18,
  19: navigationIcons.icon19,
  20: navigationIcons.icon20,
  21: navigationIcons.icon21,
  22: navigationIcons.icon22,
  23: navigationIcons.icon23,
  24: navigationIcons.p5js,
  25: homePageImages.portalLogo,
  26: homePageImages.back,
};

// Backward compatibility alias
export const customBlocksImages = blockIcons;

export {
  music_note_1,
  music_note_2,
  music_note_3,
  music_note_4,
  music_note_5,
  music_note_6,
  music_note_7,
  instrument2_note_1,
  instrument2_note_2,
  instrument2_note_3,
  instrument2_note_4,
  instrument2_note_5,
  instrument2_note_6,
  instrument2_note_7,
  instrument4_note_1,
  instrument4_note_2,
  instrument4_note_3,
  instrument4_note_4,
  instrument4_note_5,
  instrument4_note_6,
  instrument4_note_7,
  instrument5_note_1,
  instrument5_note_2,
  instrument5_note_3,
  instrument5_note_4,
  instrument5_note_5,
  instrument5_note_6,
  instrument5_note_7,
  instrument6_note_1,
  instrument6_note_2,
  instrument6_note_3,
  instrument6_note_4,
  instrument6_note_5,
  instrument6_note_6,
  instrument6_note_7,
};
